import clsx from "clsx";
import css from "./SystemNotification.module.scss";

type Props = {
  notification: {
    html: string;
  };
};

export function SystemNotification(props: Props) {
  const { notification } = props;

  return (
    <div className={clsx(css.root, "l-full-bleed")}>
      <div className="l-wrapper" dangerouslySetInnerHTML={{ __html: notification.html }} />
    </div>
  );
}
